import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import InfoIcon from '@material-ui/icons/Info'
import Checkbox from '@material-ui/core/Checkbox'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { FormattedMessage } from 'react-intl'
import messages from '../../../messages'
import clsx from 'clsx'
import { semiConfigContext } from '../Shrna'
import { Tooltip } from '@material-ui/core'
import { useShrnaSearchTermLazyQuery } from '@src/queries/ShrnaProductSearchQuery.generated'
import { initialState } from '../Reducer'
import CircleLoader from '@src/components/CircleLoader/CircleLoader'
import { SemiConfiguratorValues } from '../../../utils/constants'

const useStyles = makeStyles((theme: Theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  contentWraper: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2),
  },
  form: {
    padding: theme.spacing(0, 6, 0, 2),
    marginTop: theme.spacing(3),
  },
  fontSize2: {
    fontSize: theme.typography.pxToRem(12),
  },
  formList: {
    padding: theme.spacing(0, 1, 0, 0),
    margin: theme.spacing(0),
    color: theme.palette.grey[300],
  },
  margin: {
    margin: theme.spacing(0, 0, 0, 0),
  },
  icon: {
    fontSize: theme.typography.pxToRem(16),
    verticalAlign: 'middle',
  },
  IconButton: {
    outlined: true,
    padding: theme.spacing(1),
    marginBottom: 2,
  },
  arrow: {
    color: theme.palette.common.white,
  },
  InfoPopup: {
    maxWidth: theme.spacing(95),
    backgroundColor: theme.palette.common.white,
    position: 'relative',
    boxShadow: theme.shadows[4],
    padding: theme.spacing(5),
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.common.black,
    borderRadius: '2%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  InfoIcon: {
    position: 'relative',
    fontSize: theme.typography.pxToRem(16),
    top: theme.spacing(0.5),
    marginLeft: theme.spacing(1.5),
  },
}))

const TrcVersion = (): JSX.Element => {
  const classes = useStyles()
  const { state, dispatch } = React.useContext(semiConfigContext)

  const [getShrnaSearchTerm, { data, loading }] = useShrnaSearchTermLazyQuery()

  const searchResult = async (obj): Promise<void> => {
    await getShrnaSearchTerm({ variables: { input: obj } })
  }

  const getValue = (event, keys): void => {
    dispatch({ type: 'SET_IS_ALL_CHECKED', data: false })
    dispatch({ type: 'SET_PAGINATION_PAGE', data: 1 })
    if (state.stepNo !== 1) {
      dispatch({ type: 'TRACE_ON_CLICK', data: true })
    }
    dispatch({
      type: 'UPDATE_DROP_DOWN',
      data: initialState.shrnaDropDownValue,
    })
    dispatch({
      type: 'UPDATE_DROPDOWN_RESPONSE',
      data: initialState.shrnaDropDownResponseList,
    })
    dispatch({
      type: 'UPDATE_PRICE_CALL_RESPONSE',
      data: initialState.priceCallResponse,
    })
    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: initialState.priceCallData,
    })
    dispatch({
      type: 'UPDATE_SPECIFICATION_VALUES',
      data: initialState.specificationValues,
    })
    let trcArr: string[] = state.searchValue.facet
    if (trcArr.indexOf(`trc:${keys}`) === -1 && keys.length !== 0) {
      trcArr = trcArr.concat(`trc:${keys}`)
      dispatch({
        type: 'UPDATE_TRC_CHECK_BOX',
        data: { ...state.trcCheckboxes, [keys]: true },
      })
      dispatch({
        type: 'UPDATE_SEARCH_TERM',
        data: { ...state.searchValue, facet: trcArr },
      })
    } else if (keys.length !== 0) {
      trcArr = trcArr.filter((item) => item !== `trc:${keys}`)
      dispatch({
        type: 'UPDATE_TRC_CHECK_BOX',
        data: { ...state.trcCheckboxes, [keys]: false },
      })
    }
    const updateData = { ...state.searchValue, facet: trcArr, page: 1 }
    dispatch({
      type: 'UPDATE_SEARCH_TERM',
      data: { ...state.searchValue, facet: trcArr, page: 1 },
    })
    searchResult(updateData)
  }

  React.useEffect(() => {
    if (data !== undefined) {
      if (!data.getShrnaSearchTerm?.serverError) {
        dispatch({
          type: 'UPDATE_SEARCH_RESPONSE',
          data: data.getShrnaSearchTerm,
        })

        if (
          data.getShrnaSearchTerm.count !== null &&
          data.getShrnaSearchTerm.count !== undefined
        ) {
          dispatch({
            type: 'UPDATE_PAGINATION_DATA',
            data: {
              ...state.paginationData,
              totalCount: data.getShrnaSearchTerm.count,
            },
          })
        }
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: SemiConfiguratorValues.InternalServerError,
        })
        window.scrollTo(0, 0)
      }
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <semiConfigContext.Provider value={{ state, dispatch }}>
      <div className={classes.contentWraper}>
        <Grid container spacing={1}>
          <Grid item className={classes.margin}>
            <div>
              <h1 className={clsx(classes.heading)}>
                {<FormattedMessage {...messages.SEMI_CONF_TRC_VERSION_shrna} />}
                <span>
                  <Tooltip
                    title={
                      <React.Fragment>
                        <FormattedMessage
                          {...messages.SEMI_CONF_TRC_VERSION_INFO_MSG1_shrna}
                        />
                        <FormattedMessage
                          {...messages.SEMI_CONF_TRC_VERSION_INFO_MSG2_shrna}
                        />
                        <div>
                          <b>
                            <FormattedMessage
                              {...messages.SEMI_CONF_TRC_VERSION_INFO_MSG3_shrna}
                            />
                          </b>
                          <FormattedMessage
                            {...messages.SEMI_CONF_TRC_VERSION_INFO_MSG4_shrna}
                          />
                        </div>
                      </React.Fragment>
                    }
                    classes={{
                      tooltip: classes.InfoPopup,
                      arrow: classes.arrow,
                    }}
                    arrow
                    placement="bottom-end"
                  >
                    <InfoIcon
                      aria-label="info"
                      className={classes.InfoIcon}
                      color="primary"
                    ></InfoIcon>
                  </Tooltip>
                </span>
              </h1>

              <FormGroup className={classes.form}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={state.searchValue.facet.indexOf('trc:1') !== -1}
                      onChange={(e) => getValue(e, '1')}
                      value={<FormattedMessage {...messages.SEMI_CONF_TRC1} />}
                      color="primary"
                      className={classes.formList}
                    />
                  }
                  label={<FormattedMessage {...messages.SEMI_CONF_TRC1} />}
                  classes={{ label: classes.fontSize2 }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      onClick={(e) => getValue(e, '2')}
                      checked={state.searchValue.facet.indexOf('trc:2') !== -1}
                      value={<FormattedMessage {...messages.SEMI_CONF_TRC2} />}
                      color="primary"
                      className={classes.formList}
                    />
                  }
                  label={<FormattedMessage {...messages.SEMI_CONF_TRC2} />}
                  classes={{ label: classes.fontSize2 }}
                />
              </FormGroup>
            </div>
          </Grid>
        </Grid>
      </div>
      {loading && <CircleLoader />}
    </semiConfigContext.Provider>
  )
}
export default TrcVersion
